<template>
  <div>
    <!-- <GlobalTable
      :enableAddButton ="true"
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="true"
      :isLoading="isLoading"
      @addForm="addForm"
    ></GlobalTable> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :listBoxSource="listBoxSource"
                :visibilityShow="visibilityShow"
                :title="title"
                @addForm="addForm"
                @showHide="showHide"
                @exportXls="exportXls"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :selectionmode="''"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
           <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>
      <Loading v-if="isLoading"></Loading>

      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="12">
              <CRow>
                <CCol sm="3">
                  <CInput label="Seller Name" invalid-feedback="Seller name should be filled" required v-model="$v.agentForm.name.$model" :is-valid="!$v.agentForm.name.$invalid"/>
                </CCol>
                <CCol sm="3">
                  <CInput label="Email" invalid-feedback="Email should be filled" required v-model="$v.agentForm.email.$model" :is-valid="!$v.agentForm.email.$invalid"/>
                </CCol>
                <CCol sm="3">
                  <CInput label="Mobile Phone" invalid-feedback="Mobile Phone should be filled" required v-model="$v.agentForm.mobile_phone.$model" :is-valid="!$v.agentForm.mobile_phone.$invalid"/>
                </CCol>
                 <CCol sm="3">
                  <CInput label="Phone Number" v-model="$v.agentForm.phone_number.$model" :is-valid="!$v.agentForm.phone_number.$invalid"/>
                </CCol>
              </CRow>
              <!-- <CRow>
                <CCol sm="3">
                  <CInput label="Mobile Phone" invalid-feedback="Mobile Phone should be filled" required v-model="$v.agentForm.mobile_phone.$model" :is-valid="!$v.agentForm.mobile_phone.$invalid"/>
                </CCol>
                 <CCol sm="3">
                  <CInput label="Phone Number" v-model="$v.agentForm.phone_number.$model" :is-valid="!$v.agentForm.phone_number.$invalid"/>
                </CCol>
              </CRow> -->
              <CRow>
                <CCol sm="3">
                  <CInput label="Address" invalid-feedback="Address should be filled" required v-model="$v.agentForm.address.$model" :is-valid="!$v.agentForm.address.$invalid"/>
                </CCol>
                <CCol sm="3">
                  <CInput label="Latitude" invalid-feedback="Latitude should be filled" required v-model="$v.agentForm.lat.$model" :is-valid="!$v.agentForm.lat.$invalid"/>
                </CCol>
                <CCol sm="3">
                  <CInput label="Longitude" invalid-feedback="Longitude should be filled" required v-model="$v.agentForm.long.$model" :is-valid="!$v.agentForm.long.$invalid"/>
                </CCol>
                <CCol sm="3">
                  <CInput type="number" label="Minimal Purchase" invalid-feedback="Minimal Purchase should be filled" required v-model="$v.agentForm.minimal_purchase.$model" :is-valid="!$v.agentForm.minimal_purchase.$invalid"/>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="6">
                  <label for="description">Description</label>
                  <quill-editor
                    id="description"
                    style="height: 200px; margin-bottom: 70px"
                    :content="content"
                    :options="editorOption"
                    v-model="$v.agentForm.description.$model"
                    @change="onEditorChange($event)"
                  >
                  </quill-editor>
                  <br />
                  <div
                    v-if="$v.agentForm.description.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Description harus di isi.
                  </div>
                </CCol>
                <CCol sm="3">
                  <div class="form-group">
                    <label for="parent_flag">Is Parent</label>
                    <model-select
                      class="form-control"
                      id="parent_flag"
                      :options="agentParentList"
                      v-model="$v.agentForm.parent_flag.$model"
                      :isError="$v.agentForm.parent_flag.$invalid"
                      @input="onParentChange"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="$v.agentForm.parent_flag.$invalid"
                      class="invalid-feedback-custom"
                    >Is_parent should be filled.</div>
                  </div>
                </CCol>
                <CCol sm="3" v-if="agentForm.parent_flag === '2'">
                  <div class="form-group">
                    <label for="parent">Choose parent</label>
                    <model-select
                      class="form-control"
                      id="parent"
                      :options="parentList"
                      v-model="$v.agentForm.parent.$model"
                      :isError="$v.agentForm.parent.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="$v.agentForm.parent.$invalid"
                      class="invalid-feedback-custom"
                    >Parent should be filled.</div>
                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.agentForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import Loading from "@/templates/Loading";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "Agent",
  components: { Loading, quillEditor, JqxGrid, TableButton},
  data() {
    return {
      title: "Seller",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "agent_code", type: "string" },
          { name: "name", type: "string" },
          { name: "alias", type: "string" },
          { name: "email", type: "string" },
          { name: "description", type: "string" },
          { name: "mobile_phone", type: "number" },
          { name: "phone_number", type: "number" },
          { name: "status", type: "string" },
          { name: "parent", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,

      fields: [
        {
          datafield: "agent_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Seller Code",
        },
        {
          datafield: "name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Seller Name",
        },
        {
          datafield: "alias",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Alias",
        },
        {
          datafield: "email",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Email",
        },
        {
          datafield: "description",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Description",
          hidden:true
        },
        {
          datafield: "mobile_phone",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Mobile Phone",
        },
        {
          datafield: "phone_number",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Phone Number",
        },
        {
          datafield: "status",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Status",
          cellsalign:"center",
          align:"center",
        },
        {
          datafield: "parent",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Parent",
          hidden:true
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        }
      ],

      listBoxSource: [
        {
          label: "Parent",
          value: "parent",
          checked: false,
        },
        {
          label: "Description",
          value: "description",
          checked: false,
        }
      ],

      agentForm: tableInterfaces.agent,
      items: null,
      isLoading: false,
      isEdit: false,
      addButton: false,
      editorOption: {}, // data quill
      content:'',
      agentParentList: [
        { value: "1", text: "Yes" },
        { value: "2", text: "No" },
      ],
      parentList:[],
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations(){
    if(this.agentForm.parent_flag === '1') {
     return {
        agentForm: {
          name: { required },
          email: { required },
          mobile_phone: { required },
          phone_number: {},
          description:{},
          lat: {required},
          long: {required},
          address: { required },
          parent_flag:{required},
          minimal_purchase:{required},
          parent:{}
        }
     }
    } else {
     return {
        agentForm: {
          name: { required },
          email: { required },
          mobile_phone: { required },
          phone_number: {},
          description:{},
          lat: {required},
          long: {required},
          address: { required },
          parent_flag:{required},
          parent:{required},
          minimal_purchase:{required}
        }
     }
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      // this.cancelForm();
      this.getAgentListing();
    },
    getAgentListing: function () {
      this.isLoading = true;
      this.axios
        .get("console/agent/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            // console.log(response.data.data)
            //this.items = response.data.data;
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    submitForm: function (event) {
      event.preventDefault();
      if (confirm("Are you sure want to add this Seller ?")) {
        let path = this.$route.path.split("/");
        this.isLoading = true;
        this.axios
          .post("console/agent/add", this.agentForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
              this.$router.push({
                path: path[2] + "/detail/" + response.data.id,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.init();
          });
      }
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.productForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.agent) {
        tableInterfaces.agent[i] = null;
      }
      this.agentForm = tableInterfaces.agent;
    },
    getDropdown: function () {
      // console.log(this.agentForm.parent)
      if(this.agentForm.parent_flag === '2'){
        this.axios.get("/console/dropdown/agent_parent").then((response) => {
          // console.log(response)
          this.parentList = response.data.data;
        });
      }
    },
    onParentChange: function (event) {
      this.getDropdown()
      this.agentForm.parent = null
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
</style>
